module.exports = __webpack_public_path__ + "static/img/3.a576b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/sp/3.png
// module id = tz2D
// module chunks = 0